import { useEffect } from 'react';

export type Theme = 'base';
const DEFAULT_THEME: Theme = 'base';
const STORAGE_KEY = 'theme';
const THEME_ATTRIBUTE = 'data-theme';

const getTheme = (key: string, fallback: Theme) => {
	if (typeof window === 'undefined') return fallback;

	return (localStorage.getItem(key) || fallback) as Theme;
};

type ChimeKitThemeConfigProps = {
	theme?: Theme;
};

export function ChimeKitThemeConfig({ theme = DEFAULT_THEME }: ChimeKitThemeConfigProps) {
	const savedTheme = getTheme(STORAGE_KEY, DEFAULT_THEME);

	useEffect(() => {
		if (theme !== savedTheme) {
			document.documentElement.removeAttribute('data-theme');

			document.documentElement.setAttribute(THEME_ATTRIBUTE, theme);
			localStorage.setItem(STORAGE_KEY, theme);
		}
	}, [savedTheme, theme]);

	return null;
}
